<template>
  <div class="concern-companies-container">
    <div v-if="showUnread" @click="onShowNewMessage" class="row unread-message">
      <img class="icon" src="../../assets/img/arrow-up.svg" alt="">
      <div class="unread-count">{{latestCompanyNewsData.length}}条新闻</div>
    </div>
    <div class="row concern-companies-content">
      <div class="concern-companies-content-left">
        <header-second-tabs :tabs="tabs" @change="onTabChange">
          <div class="row">
            <div v-if="selectedOptionTab === '事件细闻'">
            </div>
            <div v-if="selectedOptionTab === '事件机会'">
              <el-select class="select" @change="onEventOptionChange" v-model="companyEventOption" placeholder="请选择">
                <el-option
                  v-for="item in companyEventOptions"
                  :key="item.value"  
                  :label="item.label"
                  :value="item.value"
                  ></el-option>
                </el-select>
              <el-checkbox v-model="eventAutoRefresh" @change="eventAutoRefreshChange"></el-checkbox>
              <span class="event-refresh-title"><span class="event-refresh-title-count">{{eventRefreshCountDown}}</span>秒后刷新</span>
              <img v-show="!eventLoading" @click="onEventAutoRefreshClick" class="refresh-icon icon" src="../../assets/img/eventLoading2.svg" alt="">
              <img v-show="eventLoading" class="refresh-icon-loading" src="../../assets/img/eventLoading1.gif" alt="">
            </div>
            <el-checkbox v-if="isShowRelated" v-model="showRelatedCompany" @change="showRelatedCompanyChange"></el-checkbox>
            <span v-if="isShowRelated" class="checkout-title">关联公司要闻</span>
          </div>
        </header-second-tabs>
        <div v-if="showImportantNewsUnread && selectedOptionTab === '事件细闻'" @click="onShowImportantNewMessage" class="row important-news-unread-message">
          <img class="icon" src="../../assets/img/arrow-up.svg" alt="">
          <span class="important-news-unread-count">{{latestImportantNewsData.length}}条新闻</span>
        </div>
        <div v-loading="isLoading" class="recommend-focus-news-list" v-show="selectedOptionTab === '事件细闻'">
          <div>
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
              <transition-group name="focus-list">
                <ConcernFocusNewsItem class="recommend-focus-news-item" v-for="(item, index) in focusNewsList" :key="index" :data="item"></ConcernFocusNewsItem>
              </transition-group>
            </div>
          </div>
        </div> 
        <div v-loading="isLoading" class="recommend-event-news-list" v-show="selectedOptionTab === '事件机会'">
          <div>
            <div v-infinite-scroll="loadMoreEvent" infinite-scroll-disabled="eventBusy" infinite-scroll-distance="10">
              <ConcernEventNewsItem v-for="(item, index) in eventList" :key="index" :data="item" :showIcon=false></ConcernEventNewsItem>
            </div>
          </div>
        </div>
        <div class="concern-companies-content-left-div"></div>
      </div>
      <div class="concern-companies-content-right">
        <!-- <real-time-data :data="realTimeData" :year="year" :month="month" :date="date" :day="day" :hour="hour" :minute="minute" :second="second"></real-time-data> -->
        <div class="concern-companies-content-right-hot-companies">
          <sn-header :title="'公司热度'">
            <div>
              <el-select class="concern-companies-content-right-hot-companies-market" @change="onMonitorCompanyHeatGroupChange" v-model="monitorCompanyHeatGroup" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select class="concern-companies-content-right-hot-companies-sentiment" @change="onMonitorCompanySentimentChange" v-model="monitorCompanySentiment" placeholder="请选择">
                <el-option
                  v-for="item in monitorCompanySentimentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </sn-header>
          <div v-loading="isMonitorCompanyRankLoading" class="concern-companies-content-right-hot-companies-content">
            <concern-company-hot-ranking :data="monitorCompanyRankData" :width="290" :sentiment="monitorCompanySentiment"></concern-company-hot-ranking>
          </div>
        </div>
        <div class="concern-companies-content-right-div"></div>
      </div>
    </div>
    <div class="concern-companies-news-list">
      <sn-header :title="'公司舆情新闻列表'">
        <div>
          <SnDatePicker class="sn-date-picker" @timeChange="timeChange"></SnDatePicker>
          <el-select class="concern-companies-news-list-select set-vertical-align" @change="onMonitorCompanyNewsListGroupChange"  v-model="newsListOption" placeholder="组别">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select class="concern-companies-news-list-select set-vertical-align" @change="onInewsImportanceLeverChange"  v-model="inewsImportanceLever" placeholder="重要程度">
            <el-option
              v-for="item in inewsImportanceLeverOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button @click="onShowCompaniesFilter" class="concern-companies-news-list-filter-btn set-vertical-align">
            <img src="../../assets/img/show-filter-icon.svg" class="concern-companies-news-list-filter-btn-img icon" alt="">
            舆情类别筛选
          </el-button>
            <el-tooltip 
            class="item" 
            effect="dark" 
            :content="cluesTip" 
            :visible-arrow="false"
            :enterable="false"
            popper-class="clues-tip"
            placement="bottom-start"
          >
            <el-button v-if="showClues" @click="showClues = false" class="clues-show-btn set-vertical-align"><img class="icon" :src="require('../../assets/img/clues.svg')" alt=""></el-button>
            <el-button v-else @click="showClues = true" class="clues-show-btn set-vertical-align"><img class="icon" :src="require('../../assets/img/clues.svg')" alt=""></el-button>
          </el-tooltip>
        </div>
      </sn-header>
      <div v-show="ShowCompaniesFilter">
        <CriteriaSearchArea v-if="filterTag" :filterTag="filterTag" @checkedArr="checkedArr"/>
      </div>
      <div class="concern-companies-news-list-content" v-loading="newsListIsLoading">
        <div v-infinite-scroll="loadMoreNewsList" infinite-scroll-disabled="newsListbusy" infinite-scroll-distance="10">
          <news-list-item
            v-for="(item, index) in newsListResultData"
            :key="index"
            :data="item"
            :showClues="showClues"
          ></news-list-item>
        </div>
      </div>
      <div class="loading" v-if="newsListItemData.length && newsListResultData.length && totalCount>newsListPageSize">
        <div class="loading-word">加载中...</div>
      </div>
      <div class="loading" v-if="!newsListItemData.length && newsListResultData.length || (totalCount>0 && totalCount<=newsListPageSize)">
        <div class="loading-word">没有更多了</div>
      </div>
    </div>
  </div>
</template>

<script>
// import RealTimeData from '@/components/concern/RealTimeData';
import HeaderSecondTabs from '@/components/common/HeaderSecondTabs';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import ConcernFocusNewsItem from '@/components/concern/ConcernFocusNewsItem';
import SnHeader from '@/components/common/SnHeader';
import CriteriaSearchArea from '@/components/news-monitor/CriteriaSearchArea';
import NewsListItem from '@/components/news-monitor/NewsListItemV2';
import ConcernEventNewsItem from '@/components/concern/ConcernEventNewsItem';
import ConcernCompanyHotRanking from '@/components/common/ConcernCompanyHotRanking';
import SnDatePicker from '@/components/common/SnDatePicker';

export default {
  data() {
    return {
      inewsImportanceLever: '重要程度',
      inewsImportanceLeverData: [],
      inewsImportanceLeverOptions: [
        {
          value: '不限',
          label: '不限'
        },
        {
          value: '重要新闻',
          label: '重要新闻'
        },
        {
          value: '次要新闻',
          label: '次要新闻'
        },
        {
          value: '普通新闻',
          label: '普通新闻'
        }
      ],
      isMonitorCompanyRankLoading: false,
      totalCount: 0,
      eventLoading: false,
      dateRange: [],
      scrollTopCompanyNewsTimer: null,
      latestCompanyNewsData: [],
      showUnread: false,
      concernCompanyNewsListDoc: null,

      latestImportantNewsTimer: null,
      latestImportantNewsData: [],
      showImportantNewsUnread: false,
      importantNewsDoc: null,
      eventId: -1,
      monitorCompanyGroups: [],
      importantNewsTimer: null,
      companyNewsListTimer: null,
      latestImportantNewsId: -1,
      eventTimerFunction: null,
      eventRefreshCountDown: 60,
      eventAutoRefresh: true,
      eventSearchText: '',
      importantNewsSearchText: '',
      eventTimer: null,
      eventList: [],
      eventItemData: [],
      eventBusy: false,
      showClues: true,
      newsListTimer: null,
      newsListbusy: false,
      newsListResultData: [],
      newsListIsLoading: false,
      newsListItemData: [],
      newsListPageSize: 20,
      newsListEarliestNewsId: -1,
      newsListEarliestDateNum: -1,
      newsListLatestDateNum: -1,
      groups: [],
      negative: [],
      positive: [],
      typeTag: 'all',
      filterTag: null,
      ShowCompaniesFilter: true,
      tabs: ['事件机会', '事件细闻'],
      selectedOptionTab: '事件机会',
      showRelatedCompany: false,
      busy: false,
      isLoading: false,
      timer: null,
      username: '',
      eventPageNum: 1,
      pageSize: 20,
      earliestNewsId: -1,
      earliestDateNum: -1,
      latestDateNum: -1,
      itemData: [],
      focusNewsList: [],
      realTimeData: [],
      newsListOption: '全部',
      options: [
        {
          value: '全部',
          label: '全部'
        }
      ],
      companyEventOption: 'min_publish_date',
      companyEventOptions: [
        {
          value: 'heat',
          label: '事件热度'
        },
        {
          value: 'max_publish_date',
          label: '最新报道'
        },
        {
          value: 'min_publish_date',
          label: '首篇报道'
        }
      ],
      monitorCompanyHeatGroup: '全部',
      monitorCompanySentiment: '不限正负',
      monitorCompanyRankData: [],
      monitorCompanySentimentOptions: [
        {
          value: '不限正负',
          label: '不限正负'
        },
        {
          value: '正面',
          label: '正面'
        },
        {
          value: '负面',
          label: '负面'
        }
      ]
    };
  },
  props: {
    year: {
      typeof: Number
    },
    month: {
      typeof: Number
    },
    date: {
      typeof: Number
    },
    day: {
      typeof: Number
    },
    hour: {
      typeof: Number
    },
    minute: {
      typeof: Number
    },
    second: {
      typeof: Number
    },
    companyCount: {
      typeof: Number
    }
  },
  computed: {
    isShowRelated() {
      return this.companyCount > 0 && this.companyCount <= 500;
    },
    cluesTip() {
      return this.showClues ? '隐藏线索' : '显示线索';
    }
  },
  methods: {
    onInewsImportanceLeverChange(res) {
      this.getLatestMonitorCompanyNewsSetInterval(false);
      switch (res) {
        case '不限':
          this.inewsImportanceLever = '重要程度';
          this.inewsImportanceLeverData = [];
          break;
        case '重要新闻':
          this.inewsImportanceLeverData = ['高'];
          break;
        case '次要新闻':
          this.inewsImportanceLeverData = ['中'];
          break;
        case '普通新闻':
          this.inewsImportanceLeverData = ['低'];
          break;
        default:
          break;
      }
      this.newsListItemData = [];
      this.newsListResultData = [];
      this.totalCount = 0;
      this.newsListEarliestNewsId = -1;
      this.newsListEarliestDateNum = -1;
      this.newsListLatestDateNum = -1;
      this.getMonitorCompanyNewsList();
    },
    timeChange(date) {
      this.getLatestMonitorCompanyNewsSetInterval(false);
      this.dateRange = date || [];
      this.newsListItemData = [];
      this.newsListResultData = [];
      this.totalCount = 0;
      this.newsListEarliestNewsId = -1;
      this.newsListEarliestDateNum = -1;
      this.newsListLatestDateNum = -1;
      this.getFirstMonitorCompanyNewsList();
    },
    onEventOptionChange(res) {
      this.companyEventOption = res;
      this.eventPageNum = 1;
      this.eventId = -1;
      this.eventItemData = [];
      this.eventList = [];
      this.getMonitorCompanyEvent(false);
      this.eventRefreshCountDown = 60;
    },
    onMonitorCompanyNewsListGroupChange(res) {
      this.getLatestMonitorCompanyNewsSetInterval(false);
      this.newsListItemData = [];
      this.newsListResultData = [];
      this.positive = [];
      this.negative = [];
      this.totalCount = 0;
      this.newsListEarliestNewsId = -1;
      this.newsListEarliestDateNum = -1;
      this.newsListLatestDateNum = -1;
      this.newsListOption = res;
      this.getMonitorCompanyTags();
      this.getFirstMonitorCompanyNewsList();
    },
    onMonitorCompanyHeatGroupChange(res) {
      this.monitorCompanyHeatGroup = res;
      this.monitorCompanyRankData = [];
      this.getMonitorCompanyRank();
    },
    onMonitorCompanySentimentChange(res) {
      this.monitorCompanyRankData = [];
      this.monitorCompanySentiment = res;
      this.getMonitorCompanyRank();
    },
    onEventAutoRefreshClick() {
      this.eventPageNum = 1;
      this.eventId = -1;
      this.eventLoading = true;
      this.getMonitorCompanyEvent(true);
      this.eventRefreshCountDown = 60;
    },
    getRecommendEventSetInterval(start) {
      if (this.eventTimerFunction) {
        clearTimeout(this.eventTimerFunction);
      }
      if (start) {
        this.eventTimerFunction = setTimeout(() => {
          if (this.eventRefreshCountDown > 0) {
            this.eventRefreshCountDown--;
          } else {
            this.eventPageNum = 1;
            this.eventId = -1;
            this.eventRefreshCountDown = 60;
            this.getMonitorCompanyEvent(true);
          }
          this.getRecommendEventSetInterval(start);
        }, 1000);
      } else {
        this.eventRefreshCountDown = 60;
      }
    },
    eventAutoRefreshChange(res) {
      this.getRecommendEventSetInterval(res);
    },
    checkedArr({ negative, positive }) {
      this.getLatestMonitorCompanyNewsSetInterval(false);
      this.newsListItemData = [];
      this.newsListResultData = [];
      this.positive = positive;
      this.negative = negative;
      this.totalCount = 0;
      this.newsListEarliestNewsId = -1;
      this.newsListEarliestDateNum = -1;
      this.newsListLatestDateNum = -1;
      this.getFirstMonitorCompanyNewsList();
    },
    onShowCompaniesFilter() {
      this.ShowCompaniesFilter = !this.ShowCompaniesFilter;
    },
    showRelatedCompanyChange(res) {
      if (this.selectedOptionTab === '事件细闻') {
        this.getLatestImportantNewsSetInterval(false);
        this.showRelatedCompany = res;
        this.itemData = [];
        this.earliestNewsId = -1;
        this.earliestDateNum = -1;
        this.latestDateNum = -1;
        this.focusNewsList = [];
        this.getFirstMonitorImportantNews();
      }
      if (this.selectedOptionTab === '事件机会') {
        this.getRecommendEventSetInterval(false);
        this.eventPageNum = 1;
        this.eventId = -1;
        this.eventItemData = [];
        this.eventList = [];
        this.showRelatedCompany = res;
        this.getMonitorCompanyEvent(false);
        this.eventRefreshCountDown = 60;
        this.getRecommendEventSetInterval(this.eventRefreshCountDown);
      }
    },
    onTabChange({ item }) {
      this.selectedOptionTab = item;
      if (this.selectedOptionTab === '事件机会') {
        this.getRecommendEventSetInterval(false);
        this.getLatestImportantNewsSetInterval(false);
        this.companyEventOption = 'min_publish_date';
        this.eventPageNum = 1;
        this.eventId = -1;
        this.eventItemData = [];
        this.eventList = [];
        this.getMonitorCompanyEvent(false);
        this.getRecommendEventSetInterval(this.eventRefreshCountDown);
      } else if (this.selectedOptionTab === '事件细闻') {
        this.getRecommendEventSetInterval(false);
        this.getLatestImportantNewsSetInterval(false);
        this.itemData = [];
        this.earliestNewsId = -1;
        this.earliestDateNum = -1;
        this.latestDateNum = -1;
        this.focusNewsList = [];
        this.getFirstMonitorImportantNews();
      }
    },
    getMonitorCompanyEvent(getDate = false) {
      const params = {
        user: this.username,
        page_num: this.eventPageNum,
        page_size: 20,
        show_related_company: this.showRelatedCompany,
        event_id: this.eventId,
        order: this.companyEventOption
      };
      this.isLoading = true;
      if (this.showRelatedCompany) {
        QuestionQuery.getMonitorCompanyEvent(params).then(res => {
          if (this.eventLoading) {
            this.eventLoading = false;
          }
          this.isLoading = false;
          if (res.length) {
            if (getDate) {
              this.eventItemData = [];
              this.eventList = [];
            }
            this.eventItemData = res.map(item => {
              return {
                heat: item.heat,
                title: item.title,
                count: item.count,
                firstTime: item.min_publish_date,
                lastTime: item.max_publish_date,
                eventId: item.event_id,
                sentiment: item.sentiment,
                monitorCompanies: item.monitor_companies,
                relatedCompanies: item.related_companies
              };
            });
            this.eventId = res[res.length - 1].event_id;
            for (let i = 0; i < this.eventItemData.length - 1; i++) {
              for (let j = i + 1; j < this.eventItemData.length; j++) {
                if (this.eventItemData[i].title === this.eventItemData[j].title) {
                  this.eventItemData[i].monitorCompanies = this.eventItemData[i].monitorCompanies.concat(this.eventItemData[j].monitorCompanies);
                  for (let x = 0; x < this.eventItemData[i].monitorCompanies.length - 1; x++) {
                    for (let y = x + 1; y < this.eventItemData[i].monitorCompanies.length; y++) {
                      if (this.eventItemData[i].monitorCompanies[x].name === this.eventItemData[i].monitorCompanies[y].name) {
                        this.eventItemData[i].monitorCompanies.splice(y, 1);
                        y--;
                      }
                    }
                  }
                  this.eventItemData.splice(j, 1);
                  j--;
                } 
              } 
            }
            for (let m = 0; m < this.eventList.length - 1; m++) {
              for (let n = 0; n < this.eventItemData.length - 1; n++) {
                if (this.eventList[m].title === this.eventItemData[n].title) {
                  this.eventItemData.splice(n, 1);
                  n--;
                } 
              } 
            }
            this.eventList = this.eventList.concat(this.eventItemData);
            this.eventBusy = false;
          } else {
            this.eventBusy = true;
          }
        },
        () => {
          this.isLoading = false;
          this.getRecommendEventSetInterval(false);
        });
      } else if (!this.showRelatedCompany) {
        QuestionQuery.getMonitorCompanyEventNonRelated(params).then(res => {
          if (this.eventLoading) {
            this.eventLoading = false;
          }
          this.isLoading = false;
          if (res.length) {
            if (getDate) {
              this.eventItemData = [];
              this.eventList = [];
            }
            this.eventItemData = res.map(item => {
              return {
                heat: item.heat,
                title: item.title,
                count: item.count,
                firstTime: item.min_publish_date,
                lastTime: item.max_publish_date,
                eventId: item.event_id,
                sentiment: item.sentiment,
                monitorCompanies: item.monitor_companies,
                relatedCompanies: item.related_companies
              };
            });
            this.eventId = res[res.length - 1].event_id;
            for (let i = 0; i < this.eventItemData.length - 1; i++) {
              for (let j = i + 1; j < this.eventItemData.length; j++) {
                if (this.eventItemData[i].title === this.eventItemData[j].title) {
                  this.eventItemData[i].monitorCompanies = this.eventItemData[i].monitorCompanies.concat(this.eventItemData[j].monitorCompanies);
                  for (let x = 0; x < this.eventItemData[i].monitorCompanies.length - 1; x++) {
                    for (let y = x + 1; y < this.eventItemData[i].monitorCompanies.length; y++) {
                      if (this.eventItemData[i].monitorCompanies[x].name === this.eventItemData[i].monitorCompanies[y].name) {
                        this.eventItemData[i].monitorCompanies.splice(y, 1);
                        y--;
                      }
                    }
                  }
                  this.eventItemData.splice(j, 1);
                  j--;
                } 
              } 
            }
            for (let m = 0; m < this.eventList.length - 1; m++) {
              for (let n = 0; n < this.eventItemData.length - 1; n++) {
                if (this.eventList[m].title === this.eventItemData[n].title) {
                  this.eventItemData.splice(n, 1);
                  n--;
                } 
              } 
            }
            this.eventList = this.eventList.concat(this.eventItemData);
            this.eventBusy = false;
          } else {
            this.eventBusy = true;
          }
        },
        () => {
          this.isLoading = false;
          this.getRecommendEventSetInterval(false);
        });
      }
    },
    getMonitorImportantNews() {
      const params = {
        username: this.username,
        pageSize: this.pageSize,
        showRelatedCompany: this.showRelatedCompany,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1
      };
      this.isLoading = true;
      if (this.showRelatedCompany) {
        QuestionQuery.getMonitorImportantNews(params).then(res => {
          this.isLoading = false;
          this.itemData = res.result;
          if (this.itemData.length) {
            this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
            this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
            this.focusNewsList = this.focusNewsList.concat(this.itemData);
            this.busy = false;
          } else {
            this.busy = true;
          }
        });
      } else if (!this.showRelatedCompany) {
        QuestionQuery.getMonitorImportantNewsNonRelated(params).then(res => {
          this.isLoading = false;
          this.itemData = res.result;
          if (this.itemData.length) {
            this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
            this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
            this.focusNewsList = this.focusNewsList.concat(this.itemData);
            this.busy = false;
          } else {
            this.busy = true;
          }
        });
      }
    },
    getFirstMonitorImportantNews() {
      const params = {
        username: this.username,
        pageSize: this.pageSize,
        showRelatedCompany: this.showRelatedCompany,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1
      };
      this.isLoading = true;
      if (this.showRelatedCompany) {
        QuestionQuery.getMonitorImportantNews(params).then(res => {
          this.isLoading = false;
          this.itemData = res.result;
          this.latestDateNum = res.result[0].dateNum;
          if (this.itemData.length) {
            this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
            this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
            this.focusNewsList = this.focusNewsList.concat(this.itemData);
            this.busy = false;
          } else {
            this.busy = true;
          }
          this.getLatestImportantNewsSetInterval(true);
        });
      } else if (!this.showRelatedCompany) {
        QuestionQuery.getMonitorImportantNewsNonRelated(params).then(res => {
          this.isLoading = false;
          this.itemData = res.result;
          this.latestDateNum = res.result[0].dateNum;
          if (this.itemData.length) {
            this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
            this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
            this.focusNewsList = this.focusNewsList.concat(this.itemData);
            this.busy = false;
          } else {
            this.busy = true;
          }
          this.getLatestImportantNewsSetInterval(true);
        });
      }
    },
    getLatestImportantNewsSetInterval(start) {
      if (this.importantNewsTimer) {
        clearTimeout(this.importantNewsTimer);
      }
      if (start) {
        this.importantNewsTimer = setTimeout(() => {
          this.getLatestMonitorImportantNews();
          this.getLatestImportantNewsSetInterval(start);
        }, 1000 * 60);
      }
    },
    getLatestMonitorImportantNews() {
      const params = {
        username: this.username,
        pageSize: 15,
        showRelatedCompany: this.showRelatedCompany,
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestDateNum
      };
      if (this.showRelatedCompany) {
        QuestionQuery.getMonitorImportantNews(params).then(res => {
          if (res.result.length) {
            this.latestDateNum = res.result[0].dateNum;
            if (this.importantNewsDoc.scrollTop >= 0 && this.importantNewsDoc.scrollTop <= 300) {
              this.showImportantNewsUnread = false;
              this.importantNewsDoc.scrollTop = 0;
              this.focusNewsList.unshift(...res.result);
            } else {
              this.showImportantNewsUnread = true;
              this.latestImportantNewsData = this.latestImportantNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestImportantNewsSetInterval(false);
        });
      } else if (!this.showRelatedCompany) {
        QuestionQuery.getMonitorImportantNewsNonRelated(params).then(res => {
          if (res.result.length) {
            this.latestDateNum = res.result[0].dateNum;
            if (this.importantNewsDoc.scrollTop >= 0 && this.importantNewsDoc.scrollTop <= 300) {
              this.showImportantNewsUnread = false;
              this.importantNewsDoc.scrollTop = 0;
              this.focusNewsList.unshift(...res.result);
            } else {
              this.showImportantNewsUnread = true;
              this.latestImportantNewsData = this.latestImportantNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestImportantNewsSetInterval(false);
        });
      }
    },
    onShowImportantNewMessage() {
      this.showImportantNewsUnread = false;
      if (this.latestImportantNewsData >= 50) {
        this.focusNewsList.unshift(...this.latestImportantNewsData);
        this.latestImportantNewsData = [];
        this.importantNewsDoc.scrollTop = 0;
      } else {
        this.focusNewsList.unshift(...this.latestImportantNewsData);
        this.latestImportantNewsData = [];
        this.latestImportantNewsTimer = setInterval(() => {
          if (this.importantNewsDoc.scrollTop) {
            this.importantNewsDoc.scrollTop = this.importantNewsDoc.scrollTop - 200;
          } else if (!this.importantNewsDoc.scrollTop || this.importantNewsDoc.scrollTop < 0) {
            clearInterval(this.latestImportantNewsTimer);
          }
        }, 50);
      }
    },
    loadMoreNewsList() {
      this.newsListbusy = true;
      if (this.newsListTimer) {
        clearTimeout(this.newsListTimer);
      }
      if (this.newsListItemData.length) {
        this.newsListTimer = setTimeout(() => {
          this.getMonitorCompanyNewsList();
        }, 500);
      }
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.itemData.length) {
        this.timer = setTimeout(() => {
          this.getMonitorImportantNews();
        }, 500);
      }
    },
    loadMoreEvent() {
      this.eventBusy = true;
      if (this.eventTimer) {
        clearTimeout(this.eventTimer);
      }
      if (this.eventItemData.length) {
        this.eventTimer = setTimeout(() => {
          this.eventPageNum++;
          this.getMonitorCompanyEvent(false);
        }, 500);
      }
    },
    getMonitorCompanyTags() {
      QuestionQuery.getMonitorCount(this.username).then(result => {
        if (result.company <= 500) {
          QuestionQuery.getMonitorCompanyTag(this.username, [this.newsListOption]).then(
            res => {
              if (Array.isArray(res) && !res.length) {
                res = {
                  negative: [],
                  positive: []
                };
              }
              // eslint-disable-next-line
              res.negative && res.negative.forEach(v => {
                v.checkAll = false;
                if (v.options) {
                  v.options.forEach(item => (item.checked = false));
                }
              });
              // eslint-disable-next-line
              res.positive && res.positive.forEach(v => {
                v.checkAll = false;
                if (v.options) {
                  v.options.forEach(item => (item.checked = false));
                }
              });
              this.filterTag = res;
            }
          );
        } else if (result.company > 500) {
          QuestionQuery.getNewsListTagV2('all', '').then(
            res => {
              if (Array.isArray(res) && !res.length) {
                res = {
                  negative: [],
                  positive: []
                };
              }
              // eslint-disable-next-line
              res.negative && res.negative.forEach(v => {
                v.checkAll = false;
                if (v.options) {
                  v.options.forEach(item => (item.checked = false));
                }
              });
              // eslint-disable-next-line
              res.positive && res.positive.forEach(v => {
                v.checkAll = false;
                if (v.options) {
                  v.options.forEach(item => (item.checked = false));
                }
              });
              this.filterTag = res;
            }
          );
        }
      });
    },
    getLatestMonitorCompanyNewsList() {
      const params = {
        user: this.username,
        pageSize: 15,
        positive: this.positive,
        negative: this.negative,
        groups: [this.newsListOption],
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.newsListLatestDateNum,
        company_importance_level: this.inewsImportanceLeverData.toString(),
        date: this.dateRange
      };
      QuestionQuery.getMonitorCompanyNewsList(params).then(res => {
        if (res.result.length) {
          this.newsListLatestDateNum = res.result[0].dateNum;
          if (this.concernCompanyNewsListDoc.scrollTop >= 0 && this.concernCompanyNewsListDoc.scrollTop <= 545) {
            this.showUnread = false;
            this.newsListResultData.unshift(...res.result);
          } else if (this.concernCompanyNewsListDoc.scrollTop > 545 && this.concernCompanyNewsListDoc.scrollTop <= 1000) {
            this.showUnread = false;
            this.concernCompanyNewsListDoc.scrollTop = 545;
            this.newsListResultData.unshift(...res.result);
          } else {
            this.showUnread = true;
            this.latestCompanyNewsData = this.latestCompanyNewsData.concat(res.result);
          }
        }
      },
      () => {
        this.getLatestMonitorCompanyNewsSetInterval(false);
      });
    },
    onShowNewMessage() {
      this.showUnread = false;
      if (this.latestCompanyNewsData.length >= 50) {
        this.newsListResultData.unshift(...this.latestCompanyNewsData);
        this.latestCompanyNewsData = [];
        this.concernCompanyNewsListDoc.scrollTop = 550;
      } else {
        this.newsListResultData.unshift(...this.latestCompanyNewsData);
        this.latestCompanyNewsData = [];
        this.scrollTopCompanyNewsTimer = setInterval(() => {
          if (this.concernCompanyNewsListDoc.scrollTop) {
            this.concernCompanyNewsListDoc.scrollTop = this.concernCompanyNewsListDoc.scrollTop - 50;
          } else if (this.concernCompanyNewsListDoc.scrollTop === 550 || this.concernCompanyNewsListDoc.scrollTop < 550) {
            clearInterval(this.scrollTopCompanyNewsTimer);
          }
        }, 15);
      }
    },
    getFirstMonitorCompanyNewsList() {
      const params = {
        user: this.username,
        pageSize: this.newsListPageSize,
        positive: this.positive,
        negative: this.negative,
        groups: [this.newsListOption],
        earliestNewsId: this.newsListEarliestNewsId,
        earliestDateNum: this.newsListEarliestDateNum,
        latestDateNum: -1,
        company_importance_level: this.inewsImportanceLeverData.toString(),
        date: this.dateRange
      };
      this.newsListIsLoading = true;
      QuestionQuery.getMonitorCompanyNewsList(params).then(res => {
        this.newsListIsLoading = false;
        this.newsListItemData = res.result;
        this.totalCount = res.totalCount;
        if (this.newsListItemData.length) {
          this.newsListLatestDateNum = res.result[0].dateNum;
          this.newsListEarliestNewsId = this.newsListItemData[this.newsListItemData.length - 1].newsId;
          this.newsListEarliestDateNum = this.newsListItemData[this.newsListItemData.length - 1].dateNum;
          this.newsListResultData = this.newsListResultData.concat(this.newsListItemData);
          this.newsListbusy = false;
        } else {
          this.newsListbusy = true;
        }
        this.getLatestMonitorCompanyNewsSetInterval(true);
      });
    },
    getLatestMonitorCompanyNewsSetInterval(start) {
      if (this.companyNewsListTimer) {
        clearTimeout(this.companyNewsListTimer);
      }
      if (start) {
        this.companyNewsListTimer = setTimeout(() => {
          this.getLatestMonitorCompanyNewsList();
          this.getLatestMonitorCompanyNewsSetInterval(start);
        }, 1000 * 60);
      }
    },
    getMonitorCompanyNewsList() {
      const params = {
        user: this.username,
        pageSize: this.newsListPageSize,
        positive: this.positive,
        negative: this.negative,
        groups: [this.newsListOption],
        earliestNewsId: this.newsListEarliestNewsId,
        earliestDateNum: this.newsListEarliestDateNum,
        latestDateNum: -1,
        company_importance_level: this.inewsImportanceLeverData.toString(),
        date: this.dateRange
      };
      this.newsListIsLoading = true;
      QuestionQuery.getMonitorCompanyNewsList(params).then(res => {
        this.newsListIsLoading = false;
        this.newsListItemData = res.result;
        this.totalCount = res.totalCount;
        if (this.newsListItemData.length) {
          this.newsListEarliestNewsId = this.newsListItemData[this.newsListItemData.length - 1].newsId;
          this.newsListEarliestDateNum = this.newsListItemData[this.newsListItemData.length - 1].dateNum;
          this.newsListResultData = this.newsListResultData.concat(this.newsListItemData);
          this.newsListbusy = false;
        } else {
          this.newsListbusy = true;
        }
      });
    },
    getMonitorCompanyCount() {
      QuestionQuery.getMonitorCompanyCount(this.username).then(res => {
        this.realTimeData = [
          {
            title: '舆情数量/条',
            count: res.total
          },
          {
            title: '负面舆情/条',
            count: res.negative
          },
          {
            title: '正面舆情/条',
            count: res.positive
          },
          {
            title: '中性舆情',
            count: res.neutral
          }
        ];
      });
    },
    getMonitorGroup() {
      QuestionQuery.getMonitorGroup(this.username).then(res => {
        this.options = res.map(item => {
          return {
            value: item,
            label: item
          };
        });
      });
    },
    getMonitorCompanyRank() {
      this.isMonitorCompanyRankLoading = true;
      QuestionQuery.getMonitorCompanyRank(this.username, [this.monitorCompanyHeatGroup], this.monitorCompanySentiment).then(res => {
        this.isMonitorCompanyRankLoading = false;
        this.monitorCompanyRankData = res;
      });
    }
  },
  components: {
    // RealTimeData,
    ConcernFocusNewsItem,
    HeaderSecondTabs,
    SnHeader,
    CriteriaSearchArea,
    NewsListItem,
    ConcernEventNewsItem,
    ConcernCompanyHotRanking,
    SnDatePicker
  },
  mounted() {
    this.importantNewsDoc = document.querySelector('.recommend-focus-news-list');
    this.concernCompanyNewsListDoc = document.documentElement;
    this.username = authService.getLoggedUserName();
    this.getMonitorCompanyEvent(false);
    this.eventAutoRefreshChange(true);
    this.getMonitorCompanyCount();
    this.getMonitorCompanyTags();
    this.getFirstMonitorCompanyNewsList();
    this.getMonitorCompanyRank();
    this.getMonitorGroup();
  },
  beforeDestroy() {
    this.getLatestMonitorCompanyNewsSetInterval(false);
    this.getLatestImportantNewsSetInterval(false);
    this.getRecommendEventSetInterval(false);
    if (this.latestImportantNewsTimer) {
      clearInterval(this.latestImportantNewsTimer);        
    }
  }
};
</script>

<style lang="scss" scoped>
.icon{
  width: 16px;
  height: 16px;
}
  .concern-companies-container {
    width: 100%;
    .unread-message {
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      padding: 0 12px;
      height: 17px;
      background-color: #636772;
      border-radius: 2px;
      z-index: 1;
      cursor: pointer;
      .unread-count {
        margin-right: 4px;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .concern-companies-content {
      width: 100%;
      .concern-companies-content-left {
        position: relative;
        margin-right: 10px;
        width: 780px;
        height: 470px;
        background-color: #ffffff;
        .select {
          margin: 0 10px;
          width: 100px;
        }
        .important-news-unread-message {
          position: absolute;
          top: 52px;
          left: 50%;
          transform: translateX(-50%);
          padding: 0 12px;
          height: 17px;
          background-color: #636772;
          border-radius: 2px;
          z-index: 1;
          cursor: pointer;
          .important-news-unread-count {
            margin-right: 4px;
            color: #ffffff;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .event-refresh-title {
          margin-left: 4px;
          margin-right: 10px;
          color: #747990;
          .event-refresh-title-count {
            display: inline-block;
            width: 17px;
            color: #45a8cc;
          }
        }
        .refresh-icon-loading {
          margin-right: 10px;
          width: 16px;
          height: 16px;
          margin-bottom: -3px;
        }
        .refresh-icon {
          margin-bottom: -3px;
          margin-right: 10px;
          cursor: pointer;
        }
        input {
          margin-right: 10px;
          margin-top: -3px;
          width: 244px;
          height: 26px;
          padding: 3px 27px 3px 12px;
          font-size: 14px;
          border: solid 2px #f7f8fc;
          border-radius: 2px;
          background-color: #f7f8fc;
          outline: none;
        }
        input::-webkit-input-placeholder{
          color: #9ea1b4;
        }
        input::-moz-placeholder{   /* Mozilla Firefox 19+ */
          color: #9ea1b4;
        }
        input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
          color: #9ea1b4;
        }
        input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
          color: #9ea1b4;
        }
        .checkout-title {
          margin-left: 4px;
          color: #464d6c;
          font-size: 14px;
        }
        .recommend-focus-news-list {
          height: 410px;
          overflow: auto;
          padding: 0 24px;
        }
        .recommend-event-news-list {
          height: 410px;
          overflow: auto;
        }
        .concern-companies-content-left-div {
          width: 100%;
          height: 16px;
          background: #ffffff;
        }
      }
      .concern-companies-content-right {
        &-hot-companies {
          display: flex;
          flex-direction: column;
          // margin-top: 10px;
          width: 420px;
          height: 454px;
          background-color: #ffffff;
          &-market {
            width: 100px;
          }
          &-sentiment {
            margin-left: 10px;
            width: 100px;
          }
          &-content {
            // height: 282px; 
            flex: 1;
            overflow: auto;
          }
        }
        .concern-companies-content-right-div {
          width: 100%;
          height: 16px;
          background-color: #ffffff;
        }
      }
    }
    .concern-companies-news-list {
      margin-top: 10px;
      padding: 0 24px 18px;
      background-color: #ffffff;
      width: 100%;
      .sn-date-picker {
        margin-right: 10px;
      }
      .filter-tag {
        background-color: #f7f8fc;
      }
      .sn-header-container {
        padding: 0;
      }
      &-select {
        margin-right: 10px;
        width: 100px;
      }
      &-filter-btn {
        height: 26px;
        width: 128px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #464d6c;
        background-color: #f7f8fc;
        font-weight: 400;
        &:hover {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:focus {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:active {
          color: #464d6c;
          background-color: #eaebef;
        }
        &-img {
          margin-bottom: -3px;
        }
      }
      .clues-show-btn {
        margin-left: 10px;
        height: 26px;
        width: 40px;
        padding: 5px 8px;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        font-weight: 400;
        color: #464d6c;
        background-color: #f7f8fc;
        &:hover {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:focus {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:active {
          color: #464d6c;
          background-color: #eaebef;
        }
      }
      .loading {
        padding: 12px 0;
        margin: 0 auto;
        height: 10px;
        width: 772px;
        color: #666666;
        text-align: center;
      }
      .concern-companies-news-list-content {
        min-height: 500px;
      }
    }
  }
  /deep/.el-select .el-input__inner {
    height: 26px;
    border: none !important; 
    border-radius: 2px;
    color: #464d6c;
    background-color: #f7f8fc !important;
    font-size: 14px;
    &:hover {
      background-color: #eaebef !important;
    }
  }
  /deep/.el-select .el-input .el-select__caret {
    font-weight: 900;
    color: #747990;
  }
</style>

